import { render, staticRenderFns } from "./CurriculumDataAny.vue?vue&type=template&id=87168a30&scoped=true&"
import script from "./CurriculumDataAny.vue?vue&type=script&lang=js&"
export * from "./CurriculumDataAny.vue?vue&type=script&lang=js&"
import style0 from "./CurriculumDataAny.vue?vue&type=style&index=0&id=87168a30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87168a30",
  null
  
)

export default component.exports